export default function satisfactionsurveys(state = [], action) {
    switch (action.type) {
        case 'ADD_CURRENT':
            return {
                ...state,
                satisfactionsurvey: action.satisfactionsurvey,
            }
        default:
            return state;
    }
}
